import { ButtonEvent } from "appworks/graphics/elements/button-element";
import { ToggleElement } from "appworks/graphics/elements/toggle-element";
import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { gameLayers } from "game-layers";

export class TGRBetScreenSceneTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        return new Contract((resolve: (value?: any) => void) => {
            const toggle: ToggleElement = gameLayers.Menus.getToggle("checkbox");
            toggle.setChecked(false);
            gameLayers.Menus.getFlexiButton("continue").on(ButtonEvent.CLICK, () => {
                const checked: boolean = toggle.getChecked();
                Services.storage.set("epic-tgr-dsa", checked);
                resolve();
            });
        });
    }
}
